//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { iosInput, htmlToText } from '@/tools/index.js'
import { mapGetters } from 'vuex'
import dropdownRadio from './dropdown_radio'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  data () {
    return {
      singleSelectValue: '',
      singleSelectText: '',
      rule: {
        custom: {
          singleSelectText: {
            required: () => '请选择一个选项',
          }
        }
      }
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number
    },
    readonly: {
      type: Boolean
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  mounted () {
    this.$validator.localize('zh_CN', this.rule);
    //已答的题挂上答案
    if (this.question.v_answer) {
      //选中选项
      const id = this.question.v_answer.currentValue
      this.singleSelectText = this.findSingleSelectText(id)
      this.singleSelectValue = id
    }
    console.log(this.question.v_answer);
  },
  computed: {
    ...mapGetters(['questionnaireList'])
  },
  watch: {
    async singleSelectValue (n ,o) {
      const param = {
        index: this.index,
        v_answered: !!n
      }
      let v_answer = {}
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)
      if (!param.v_answered) {
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer
        })
        // 取消回调
        this.$emit('onSelectCancel')
        return
      }
      v_answer = this.getValue()
      console.log(v_answer);
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer
      })
      //把当前选中的选项传给父组件判断子题是否显示
      this.$emit('onSelectChange')    
    }
    
  },
  methods: {
    onBlur () {
      iosInput()
    },
    getValue (value) {
      let options = []
      let checkedOption = this.question.options.find((item) => {
        return item.tenantId == this.singleSelectValue
      })
      options.push({
        tenantId: checkedOption.tenantId
      })
      return {
        tenantId: this.question.tenantId,
				type: 'dropdown_single',
				options: options,
				currentValue: [this.singleSelectValue]
      }
    },
    validate () {
      return this.$validator.validateAll()
    },
    open () {
      let self = this
      let pop = new this.$Popup(dropdownRadio, {
        position: 'bottom',
        size: '260px',
        isMask: true,
        isMaskClose: false,
        transition: true,
        question: this.question,
        onChoose(value) {
          self.singleSelectValue = value
          self.singleSelectText = self.findSingleSelectText(value)
        }
      })
    },
    findSingleSelectText (id) {
      let checkedOption = this.question.options.find((item) => {
        return item.tenantId == id
      })
      return checkedOption && htmlToText(checkedOption.text) || ''
    }
  }
}
